<template>
	<div class="content">
		<div class="content_head">
			<p>
				<input type="text" @keypress="searchCustomers" placeholder="扫描会员二维码" class="search"
					v-model="searchText" />
				<button type="button" class="button" :disabled="searchText.length<=1" @click="getCustomer()"
					title="点击查找会员">查询会员</button>
			</p>
			<p>
				会员信息: <span v-if="customer!=null" class="red">
					{{ customer.CustomerName +' '+ customer.CustomerPhone }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					账号押金:{{customer.Deposit+'元' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					待还数量:{{customer.borrowBooksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount -customer.borrowBooksCount +'本'}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					到期时间:{{ $moment (customer.VipEndDate).format('YYYY年MM月DD日') }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					办理店铺:{{customer.ShopName }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
				<p>
					<input type="text" placeholder="书籍编码|或者扫描书籍二维码" @keypress="searchBook" class="search"
						v-model="searchBookCode" />
					<button type="button" class="button" :disabled="searchBookCode.length<8" @click="getBook()"
						title="点击进行查找">查找书籍</button>
				</p>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>书籍名称</th>
							<td>
								图书详情
							</td>
							<th>售出数量</th>
							<td>移除</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in books">
							<td>{{index+1}}</td>
							<td>
								{{i.BooksName}}
							</td>
							<td>
								<p style="text-align: right !important;" v-for="y in i.books" class="borrowBooks">
									编号: <span class="red"> {{ y.BooksNumCode}} </span>&nbsp;&nbsp;
									价格: <span class="red"> &yen;{{ y.BookPrice+'元'}} </span>&nbsp;&nbsp;
									位置: <span class="red">{{y.ShopName+' ' +y.CurrentPlace}}</span>&nbsp;&nbsp;
									<span class="red"> 实付:<input type="text"  style="text-align: right;width: 2rem;" v-model="y.payMoney" />元</span>
								</p>
							</td>

							<td>
								{{i.count}}
							</td>
							<td><button type="button" @click='removeBook(index)' class="button">移除</button></td>
						</tr>
					</tbody>
				</table>

			</div>

		</div>
		<p style="text-align: right; color:  red;font-size: 1.3rem;">
			<span>实付金额:</span>
			<input type="text" style="width: 4rem;" class="right"  :disabled="true" v-model="payMoney" />元&nbsp;&nbsp;
			{{borrowCountSum}}
			<button class="button" @click="borrowBooks">提交</button>
		</p>
	</div>

</template>

<script>
	import j from './j.js'
	export default j
</script>

<style>
</style>
